export default {
  key: "chatbot",
  basePath: "/chatbot",
  exclude: false,
  components: [
    {
      name: "chatbot",
      component: () => import("./component/chatbot.vue"),
    },
  ],
};
